import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { RequestService } from '../../verify-request/request-service';
import { NgxOtpInputComponent } from 'ngx-otp-input';
import { AlertNotificationsService } from '../../../../services/alert-notifications.service';
import { Router } from '@angular/router';
import { CustomerAreaService } from '../../../../services/my-quotes-parameters.service';
@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css'],
  standalone: false
})
export class OtpComponent implements OnInit {

  @Input() phoneNumber = '';
  @Input() token = '';
  @Input() otpConfirmed = false;
  otpCode?: string;
  countdown = 60;
  @Input() endButtonText = ''
  showOtpInput = true;
  @ViewChild('otpInput', { static: false }) otpInput?: NgxOtpInputComponent;

  constructor(private requestService: RequestService,
    private notificationsService: AlertNotificationsService,
    private customerAreaService: CustomerAreaService,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    this.startCountdown();
  }

  async sendOtp() {
    try {
      await this.requestService.resendOtp(this.token);
    } catch (error) {
      console.error('Error sending OTP:', error);
    }
  }

  async resendCode() {
    this.countdown = 60;
    await this.sendOtp();
    this.startCountdown();
  }

  onOtpChange(otp: any) {
    this.otpCode = otp;
    if (this.otpCode?.length === 5) {
      this.verify();
    }
  }

  reset() {
    this.otpCode = '';
    this.showOtpInput = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.showOtpInput = true;
      this.cdr.detectChanges();
    }, 0);
  }


  async verify() {
    try {
      await this.requestService.verifyIdentity(this.token, this.otpCode);
    } catch (error: any) {
      // 410 = codice scaduto, 422 = codice errato (vedi GlobalExceptionHandler lato backend)
      this.notificationsService.error(error?.status === 410
        ? 'This code has expired. Request a new one.'
        : 'Invalid OTP code. Please try again.');
      this.reset();
      console.error('Error verifying OTP:', error);
      return;
    }

    try {
      await this.goToMyQuotes();
    } catch (error) {
      this.notificationsService.error('Could not load your quotes. Please reload the page.');
      console.error('Error loading customer area:', error);
    }
  }

  async goToMyQuotes() {
    await this.customerAreaService.loadCustomerArea(this.token);
  }

  startCountdown() {
    const interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(interval);
      }
    }, 1000);
  }
}
